import type { ExtensionExecutionContext } from '../types';
import type {
  ExtensionCondition,
  ExtensionConditions,
  ExtensionDiscountCodeCondition,
} from '@getjust/checkout-extensions';

/**
 * Evaluates extension conditions
 */
export class ExtensionConditionEvaluator {
  /**
   * Evaluate conditions against context
   */
  evaluate(conditions: ExtensionConditions, context: ExtensionExecutionContext): boolean {
    if (!conditions || !conditions.conditions || conditions.conditions.length === 0) {
      return true;
    }

    const { strategy, conditions: conditionList } = conditions;
    const results = conditionList.map((condition) => this.evaluateCondition(condition, context));

    if (strategy === 'all') {
      return results.every(Boolean);
    } else if (strategy === 'any') {
      return results.some(Boolean);
    }

    return true;
  }

  /**
   * Evaluate a single condition
   */
  private evaluateCondition(condition: ExtensionCondition, context: ExtensionExecutionContext): boolean {
    try {
      switch (condition.type) {
        case 'discount-code':
          return this.evaluateDiscountCode(condition, context);

        case 'product-in-cart':
          // TODO: handle (next pr)
          return false;

        default:
          return false;
      }
    } catch (error) {
      console.error(`[ConditionEvaluator] Error evaluating condition:`, error);
      return false;
    }
  }

  /**
   * Evaluate discount code condition
   */
  private evaluateDiscountCode(
    condition: ExtensionDiscountCodeCondition,
    context: ExtensionExecutionContext,
  ): boolean {
    const { operator, value } = condition;
    const discountCode = context.discountCode || '';

    switch (operator) {
      case 'eq':
        return discountCode === value;
      default:
        return false;
    }
  }
}
